import React from "react";

import documentIcon from "../../../assets/document.png";
import labTestsIcon from "../../../assets/lab-tests.png";
import clinicalConsultationIcon from "../../../assets/clinical-consultation.png";
import monitorIcon from "../../../assets/monitor.png";
import searchIcon from "../../../assets/search.png";
import antibioticIcon from "../../../assets/antibiotic.png";

type Recommendation =
  | "ROUTINE_VITALS"
  | "VITALS_EVERY_4_HOURS"
  | "BLOOD_CULTURE_VITALS_EVERY_4_HOURS"
  | "ANTIBIOTICS_VITALS_PER_NICU";

type Props = {
  risk: string | number;
  recommendation: Recommendation;
};

export const RiskInfo: React.FC<Props> = ({ risk, recommendation }) => {
  return (
    <div style={{ textAlign: "start", padding: 16 }}>
      {/* סיכון לאלף לידות: <span className="eos-per-condition">{risk}</span> <br /> */}
        {recommendation === "ROUTINE_VITALS" && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "0.5rem",
              marginBottom: "1rem",
            }}
          >
            <img
              src={documentIcon}
              alt="Document"
              style={{ width: 20, height: 20, marginTop: 2 }}
            />
            <span>
              יש לציין את ערך הסיכון המשוקלל בגיליון היילוד.
            </span>
          </div>

          <div style={{ fontWeight: 700, marginTop: "1rem" }}>
            יש לבצע מעקב שגרתי:
          </div>

          <ul>
            <li>סימנים חיוניים אחת למשמרת.</li>
            <li>בדיקת רופא ילדים נוספת בין גיל 12 ל- 24 שעות.</li>
            <li>בדיקה נוספת בכל החמרה במצב או תוצאת סימנים חיוניים חריגה.</li>
          </ul>
        </div>
      )}
      {recommendation === "VITALS_EVERY_4_HOURS" && (
        <div>
          <ul>
            <li>
              יש לבצע מעקב קליני:
              <ul>
                <li>סימנים חיוניים כל 4 שעות.</li>
                <li>
                  בדיקת רופא פעמיים ביום ביממה הראשונה לחיים, ובהמשך לפי הערכה קלינית.
                </li>
                <li>בדיקה נוספת בכל החמרה במצב קליני או תוצאת סימנים חיוניים חריגה.</li>
              </ul>
            </li>
          </ul>
        </div>
      )}
      {recommendation === "BLOOD_CULTURE_VITALS_EVERY_4_HOURS" && (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
              marginBottom: "1rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
              <img
                src={labTestsIcon}
                alt="Lab tests"
                style={{ width: 20, height: 20, marginTop: 2 }}
              />
              <span>יש לקחת תרבית.</span>
            </div>

            <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
              <img
                src={clinicalConsultationIcon}
                alt="Clinical consultation"
                style={{ width: 20, height: 20, marginTop: 2 }}
              />
              <span>להפעיל שיקול קליני כוללני בייעוץ עם רופא בכיר.</span>
            </div>
          </div>

          <div style={{ fontWeight: 700, margin: "1rem 0" }}>
            יש לבצע מעקב קליני:
          </div>

          <ul>
            <li>סימנים חיוניים כל 4 שעות.</li>
            <li>
              בדיקת רופא פעמיים ביום ביממה הראשונה לחיים, ובהמשך לפי הערכה קלינית.
            </li>
            <li>בדיקה נוספת בכל החמרה במצב קליני או תוצאת סימנים חיוניים חריגה.</li>
          </ul>
        </div>
      )}
      {recommendation === "ANTIBIOTICS_VITALS_PER_NICU" && (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
              marginBottom: "1rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
              <img
                src={monitorIcon}
                alt="Continuous monitoring"
                style={{ width: 20, height: 20, marginTop: 2 }}
              />
              <span>ניטור רציף</span>
            </div>

            <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
              <img
                src={searchIcon}
                alt="Diagnostic evaluation"
                style={{ width: 20, height: 20, marginTop: 2 }}
              />
              <span>התוויה לבירור.</span>
            </div>

            <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
              <img
                src={antibioticIcon}
                alt="Empiric antibiotics"
                style={{ width: 20, height: 20, marginTop: 2 }}
              />
              <span>נדרש טיפול אנטיביוטי אמפירי.</span>
            </div>
          </div>

          <div style={{ fontWeight: 700, margin: "1rem 0" }}>
            יש לבצע מעקב קליני:
          </div>

          <ul>
            <li>סימנים חיוניים כל 4 שעות.</li>
            <li>
              בדיקת רופא פעמיים ביום ביממה הראשונה לחיים, ובהמשך לפי הערכה קלינית.
            </li>
            <li>בדיקה נוספת בכל החמרה במצב קליני או תוצאת סימנים חיוניים חריגה.</li>
          </ul>
        </div>
      )}
    </div>
  );
};